import { GzCheckboxWebComponent } from 'apps/webcomponents/src/ui/gzCheckbox';
import { GzDialogWebComponent } from 'apps/webcomponents/src/ui/gzDialog';
import { GzDialog, GzDialogEvents } from 'apps/webcomponents/src/ui/gzDialog/component/GzDialog';
import { WEB_COMPONENT_GZ_CHECKBOX } from 'apps/webcomponents/src/webcomponents.constants';
import { Permissions } from '../../exchangeProtection/types';
import { attachDialogFooterListeners, getDeleteDialogButtons } from '../shared/dialogUtils';

export class EmptyQuarantineDialog {
  static open(translateFn: Function, permissions: Permissions): GzDialogWebComponent {
    const bodyContent = this.getBodyContent(translateFn, permissions);
    const footerContent = getDeleteDialogButtons(translateFn);
    const dialogConfigs: GzDialog = {
      headline: translateFn('Empty Quarantine'),
      bodyContent,
      isOpen: true,
      footerContent,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs);

    const confirmCallback = function () {
      const includeSubCompanies = !!(bodyContent.querySelector(WEB_COMPONENT_GZ_CHECKBOX) as GzCheckboxWebComponent)
        ?.checked;

      dialog.emitDialogEvent(GzDialogEvents.CONFIRM, {
        includeSubCompanies,
      });
    };

    attachDialogFooterListeners(footerContent, dialog, confirmCallback);

    return dialog;
  }

  static getBodyContent(translateFn: Function, permissions: Permissions): HTMLElement {
    const wrapper = document.createElement('div');

    wrapper.innerHTML = `<p>${translateFn('Are you sure you want to delete all quarantined items?')}</p>`;

    if (permissions.canHaveChildCompanies) {
      const checkboxWrapper = document.createElement('div');
      const checkbox = new GzCheckboxWebComponent();

      checkbox.label = translateFn('Include all companies recursively');
      checkboxWrapper.classList.add('mt-4');

      checkboxWrapper.appendChild(checkbox);
      wrapper.appendChild(checkboxWrapper);
    }

    return wrapper;
  }
}
